import type { SharedProjectSummary } from "@vorloop/api-client-react";

const TYPE_LABEL: Record<SharedProjectSummary["type"], string> = {
  mobile: "Mobile App",
  web: "Web App",
  component: "UI Component",
  backend: "Backend",
};

/**
 * "Shared with me" — projects the user has been added to as an editor
 * or viewer via project_members. Sits below "Your recent Projects".
 */
export function SharedProjects({ items }: { items: ReadonlyArray<SharedProjectSummary> }) {
  return (
    <section style={{ width: "100%", maxWidth: 1040 }}>
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 12,
        }}
      >
        <h2 style={{ fontSize: 14, fontWeight: 600, margin: 0 }}>Shared with me</h2>
        <span style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
          {items.length} project{items.length === 1 ? "" : "s"}
        </span>
      </header>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 12,
        }}
      >
        {items.map((p) => (
          <a
            key={p.id}
            href={`/editor/${p.id}`}
            style={{
              border: "1px solid var(--border-default)",
              borderRadius: 12,
              background: "var(--bg-panel)",
              overflow: "hidden",
              color: "var(--text-primary)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              aria-hidden
              style={{
                height: 110,
                background:
                  p.type === "mobile"
                    ? "linear-gradient(135deg,#1f2937,#0f172a)"
                    : p.type === "web"
                      ? "linear-gradient(135deg,#1e293b,#0f172a)"
                      : "linear-gradient(135deg,#312e81,#0f172a)",
                borderBottom: "1px solid var(--border-default)",
              }}
            />
            <div style={{ padding: 12, display: "flex", flexDirection: "column", gap: 6 }}>
              <div style={{ fontWeight: 600, fontSize: 13, lineHeight: 1.2 }}>{p.name}</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
                  {TYPE_LABEL[p.type]}
                </span>
                <span
                  style={{
                    padding: "2px 8px",
                    fontSize: 10,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: 0.4,
                    background:
                      p.role === "editor"
                        ? "rgba(99,102,241,0.12)"
                        : "rgba(107,114,128,0.18)",
                    color: p.role === "editor" ? "#a5b4fc" : "#cbd5e1",
                    borderRadius: 999,
                  }}
                >
                  {p.role}
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
